import React from "react";

// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.
// Includes reassurance paragraphs merged in from the deleted Reassurance section.

const SIDE_IMG = encodeURI("/Assets/LRS Project 02.jpg");

export default function WhyLRS() {
    return (
        <section id="why" className="bg-offwhite py-12 md:py-16" data-testid="section-why">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
                <div className="order-1">
                    <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">
                        Our approach
                    </p>
                    <h2 className="font-manrope font-bold text-charcoal text-[34px] md:text-[44px] leading-[1.05] tracking-tight mb-8">
                        Design with construction in mind
                    </h2>
                    <div className="space-y-5 text-charcoal/80 font-inter text-[16px] md:text-[17px] leading-relaxed">
                        <p>
                            Our approach combines architectural design thinking with practical residential construction experience.
                        </p>
                        <p>
                            That means we consider buildability, space, budget and how the finished home will actually work from the beginning of the design process.
                        </p>
                        <p>
                            There is no obligation to appoint us for the construction.
                        </p>
                        <p className="italic font-semibold text-charcoal">
                            If you decide to use another builder after receiving your design, you will not be required to pay the design fee. It's yours to keep and use!
                        </p>
                    </div>
                </div>
                <div className="order-2 relative">
                    <div className="aspect-[4/5] md:aspect-[3/4] w-full overflow-hidden rounded-sm">
                        <img
                            src={SIDE_IMG}
                            alt="London residential interior"
                            loading="lazy"
                            className="w-full h-full object-cover object-center"
                        />
                    </div>
                    <span aria-hidden="true" className="hidden md:block absolute -bottom-3 -right-3 w-16 h-16 border-b border-r border-terracotta" />
                </div>
            </div>
        </section>
    );
}
